/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Why_Released_DescInputs */

const en_landing_why_released_desc = /** @type {(inputs: Landing_Why_Released_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shipped in Ideogram's app, its API and through launch partners on the same day.`)
};

const zh_landing_why_released_desc = /** @type {(inputs: Landing_Why_Released_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当天同步上线 Ideogram 应用、API 及合作平台。`)
};

/**
* | output |
* | --- |
* | "Shipped in Ideogram's app, its API and through launch partners on the same day." |
*
* @param {Landing_Why_Released_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_why_released_desc = /** @type {((inputs?: Landing_Why_Released_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Why_Released_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_why_released_desc(inputs)
	return zh_landing_why_released_desc(inputs)
});
export { landing_why_released_desc as "landing.why.released_desc" }